import { Component, OnInit, Input, Output, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { LocalWebStorageService } from '../storage/local-web-storage.service';
import { SessionWebStorageService } from '../storage/session-web-storage.service';
import { InMemoryStorageService } from '../storage/in-memory-storage.service';
import { LogOutService } from '../logout/logout.service';
import { Router } from '@angular/router';
import { TokenService } from '../token/token.service';

@Component({
    selector: 'signout',
    templateUrl: './sign-out.component.html',
    styleUrls: ['./sign-out.component.css']

})

export class SignOutComponent implements OnInit {
    @ViewChild('signOutIframe') iframe: ElementRef;

    constructor(private localWebStorage: LocalWebStorageService,
        private sessionWebStorageService: SessionWebStorageService,
        private inMemoryStorageService: InMemoryStorageService,
        private logoutService: LogOutService,
        private _router: Router,
        private tokenService: TokenService) {
    }

    ngOnInit() {
        // this.signOut();
    }

    onLoginAgain() {
        var link = location.protocol + '//' + location.hostname;
        if (location.port && location.port.length > 0) {
            link = link + ':' + location.port;
        }
        window.location.href = link;
    }

    signOut() {
        console.log('signOut');
        this.logoutService.signOut().subscribe((response: any) => {
            //this.iframe.nativeElement.src = response.logoutUrl;
            console.log(response.logoutUrl);
            //this.clearStorage();
        });
    }

    clearStorage() {
        this.localWebStorage.clear();
        this.sessionWebStorageService.clear();
        this.inMemoryStorageService.clear();
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/sign-out/sign-out.component.ts